import * as Type from './actionsTypes';

const loadDashboard = filterData => ({ type: Type.FETCH_DASHBOARD, filterData });

export {
  loadDashboard
}
